import { invert } from "lodash";
import * as specialtyCodes from "./specialtyCodes";
import * as FILTER_TYPES from "./filterTypes";
import {
  PracticeFilter,
  ProviderFilter,
  StateFilter,
  StatusFilter,
  PaymentMethodFilter,
  NewPatientFilter,
} from "../filters";

export const FILTERS_TO_SEARCH_PARAMS_MAPPING = {
  [FILTER_TYPES.PROVIDERS]: 'providerIds',
  [FILTER_TYPES.PRACTICES]: 'practices',
  [FILTER_TYPES.PROVIDER_LICENSES]: 'states',
  [FILTER_TYPES.STATUSES]: 'statuses',
  [FILTER_TYPES.PAYMENT_METHODS]: 'paymentMethods',
  [FILTER_TYPES.ACCEPT_NEW_PATIENTS_STATUS]: 'acceptingNewPatients',
};

export const SEARCH_PARAMS_TO_FILTERS_MAPPING = invert(FILTERS_TO_SEARCH_PARAMS_MAPPING);

export const REQUIRED_FILTERS = [
  FILTER_TYPES.PROVIDERS,
  FILTER_TYPES.PAYMENT_METHODS,
  FILTER_TYPES.PROVIDER_LICENSES,
];

export const DEFAULT_FILTERS = [
  ...REQUIRED_FILTERS,
  FILTER_TYPES.PRACTICES,
];

export const FILTERS_BY_SPECIALTY = {
  [specialtyCodes.PRIMARY_CARE]: [
    ...DEFAULT_FILTERS,
    FILTER_TYPES.STATUSES,
  ],
  [specialtyCodes.MENTAL_HEALTH]: [
    ...REQUIRED_FILTERS,
    FILTER_TYPES.ACCEPT_NEW_PATIENTS_STATUS,
  ],
};

export const FILTERS = {
  [FILTER_TYPES.PROVIDERS]: ProviderFilter,
  [FILTER_TYPES.PRACTICES]: PracticeFilter,
  [FILTER_TYPES.PROVIDER_LICENSES]: StateFilter,
  [FILTER_TYPES.STATUSES]: StatusFilter,
  [FILTER_TYPES.PAYMENT_METHODS]: PaymentMethodFilter,
  [FILTER_TYPES.ACCEPT_NEW_PATIENTS_STATUS]: NewPatientFilter,
};
